module.exports = "/_next/static/resources/photo-1-c172138823290905e9bd7a016d7ac24f.jpg";